export default __webpack_public_path__ + "static/media/629.2befa2be.gif";